import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FCollectionSelector from './FCollectionSelectorDrawer';

interface fCollectionSelectorProps {}

type ReturnData = string | null;

function fCollectionSelector({}: fCollectionSelectorProps = {}): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <FCollectionSelector
        onConfirm={(collectionID) => {
          resolve(collectionID);
        }}
        onClosed={() => {
          setTimeout(() => {
            resolve(null);
            root.unmount();
            div.remove();
          }, 1);
        }}
      />,
    );
  });
}

export default fCollectionSelector;
